import React from 'react';
import '../App.css';
import cfl from '../config.json';
import $ from 'jquery';
import config from '.././config.json';
import moment from 'moment';
import usStates from '../usStates';

import {
    Form, Input, Tooltip, Icon, Select,
    Button, DatePicker, InputNumber, Spin, notification, TimePicker, Modal, Row, Col
} from 'antd';

import { Redirect } from 'react-router';
import LoginForm from '../LoginForm.js';

const { RangePicker } = DatePicker;
const FormItem = Form.Item;
const Option = Select.Option;
const midFormItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 12 },
        sm: { span: 8 },
    },
};

class AddEmployerForm extends React.Component {

    constructor(props) {
        super(props);
        this.state.employer = {
            Id: -1, CompanyName: '', Address: '', State: 'ND',
            City: '', ZipCode: '', PhoneNumber: '', Email: ''
        };

        this.states = usStates.listofUSstates();
        this.employerDisplayList = [];
    }

    state = ({
        loading: false,
        login: true,
        emailValidatorEmployer: '',
        employerList: [],
        deleteButtonShow: true,
        filterSystem: "All"
    });

    handleChangeEmployer = (value) => {
        this.props.form.resetFields();
        this.companydropdown = value;
        for (let i = 0; i < this.state.employerList.length; i++) {
            if (this.state.employerList[i].Id == value) {
                console.log(this.state.employerList[i])
                this.setState({
                    employer: this.state.employerList[i]
                });

                this.setState({
                    inputControl: false
                });
                break;
            }
            else {
                this.setState({
                    employer: {
                        Id: -1, CompanyName: '', Address: '', State: '',
                        City: '', ZipCode: '', PhoneNumber: '', Email: ''
                    }
                });
            }

        }
        this.setState({
            inputControl: false
        });

    }

    resetForm = () => {
        this.employerDropdown();
        this.props.form.resetFields();
        this.setState({
            employer: { Id: -1, CompanyName: '', Address: '', State: 'ND', City: '', ZipCode: '', PhoneNumber: '', Email: '' }
        });
    }

    /**
   * Handles delete button click event
   */
    handleDelete = () => {
        if (window.confirm("Are you sure you want to delete the Employer?")) {
            let employerId = this.state.employer.Id
            if (employerId != -1) {
                $.ajax({
                    type: 'POST',
                    url: `${config.serverUrl}/api/employer/delete/${employerId}`,
                })
                    .done((data) => {
                        console.log(data);
                        this.resetForm();
                        const modal2 = Modal.success({
                            title: "Employer Deleted Successfully!!",
                            content: '',
                        });
                    })
                    .fail((jqXhr) => {
                        console.log('failed to register');
                        const modal2 = Modal.error({
                            title: "Deletion failed!",
                            content: 'Please move the students to different employer before deleting the selected employer!!',
                        });
                    });
            } else {
                alert("Please select an employer to delete!!")
            }
        }
    }

    /**
    * From submit event
    */
    handleSubmit = () => {
        //keeps the page from refreshing
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values)
            if (!err) {
                const employer = this.state.employer;
                employer.CompanyName = values.company;
                employer.Address = values.streetCompany;
                employer.State = values.stateCompany;
                employer.City = values.cityCompany;
                employer.ZipCode = values.zipcodeCompany;
                employer.PhoneNumber = values.phoneCompany;
                employer.Email = values.emailCompany;
                employer.System = values.system
                this.setState({
                    employer
                });



                $.ajax({
                    type: 'POST',
                    url: `${config.serverUrl}/api/students/addEditEmployer`,
                    data: this.state.employer
                })
                    .done((data) => {
                        console.log(data);
                        this.resetForm();
                        const modal = Modal.success({
                            title: "Employer Add/Edit Successful!",
                            onOk() {
                            }
                        });
                    })
                    .fail((jqXhr) => {
                        console.log('failed to register');
                        const modal2 = Modal.error({
                            title: "Registration failed!",
                            content: 'Server Error',
                        });
                    });



            }
            else {
                console.log(err);
            }
        });

    }
    /**
     * Used for custom ajax calls
     * @param {any} type
     * @param {any} url
     * @param {any} data
     * @param {any} done
     * @param {any} fail
     */
    ajaxCall(type, url, data, done, fail) {
        $.ajax({
            type: type,
            url: `${config.serverUrl}` + url,
            data: data
        })
            .done((data) => {
                done(data);
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                fail();
            });
    }


    handleEmailValidationEmployer = (e) => {
        this.setState({
            emailValidatorEmployer: 'email',
        },
            () => {
                this.props.form.validateFields(['emailCompany'], { force: true });
            });

    }

    /**
    * Used to display notifications
    */
    openNotificationWithIcon = (type, title, body) => {
        notification[type]({
            message: title,
            description: body,
        });
    };

    /**
     * Render function
     */
    render() {
        const { getFieldDecorator } = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 14 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 14,
                    offset: 6,
                },
            },
        };

        return (
            <div >
                {this.state.login ?
                    <Spin spinning={this.state.loading}>
                        <h2>Add/Edit Employer</h2>
                        <hr />
                        <div className='forms'>
                            <Form>
                            <FormItem
                                    label="Certification System"
                                    {...formItemLayout}>
                                    {getFieldDecorator('system', {
                                        initialValue: this.state.employer.System
                                    })(
                                        <Select
                                            placeholder="Select the system this employer belongs to"
                                            onChange={this.handleSelectChangeSystem}>
                                            <Option value="1">TCP/ESCC</Option>
                                            <Option value="2">External Civil Rights Training</Option>
                                        </Select>
                                    )}
                                </FormItem>
                                <FormItem
                                    {...formItemLayout}
                                    label="Select Employer from the List"
                                >
                                    {getFieldDecorator('display', {
                                        initialValue: "Other",

                                    })(
                                        <Select
                                            showSearch
                                            style={{ width: '100%' }}
                                            searchPlaceholder="Enter Company Name"
                                            optionFilterProp="children"
                                            onChange={this.handleChangeEmployer}
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            {this.employerDisplayList}
                                        </Select>)}

                                </FormItem>
                                {/*------------------------------------------ Employer Details ------------------------------------------*/}

                                <FormItem {...formItemLayout} label="Company Name">
                                    {getFieldDecorator('company', {
                                        initialValue: this.state.employer.CompanyName,
                                        rules: [{
                                            required: true, message: 'Please enter name of the company!',
                                        }],
                                    })(<Input disabled={this.state.inputControl} />)}
                                </FormItem>
                                {/*------------------------------------------ EMPLOYER ------------------------------------------*/}

                                <FormItem {...formItemLayout} label="Street" >
                                    {getFieldDecorator('streetCompany', {
                                        initialValue: this.state.employer.Address,
                                        rules: [{
                                            required: true, message: 'Please input street!',
                                        }],
                                    })(<Input disabled={this.state.inputControl} />)}
                                </FormItem>
                                <FormItem {...formItemLayout} label="City" >
                                    {getFieldDecorator('cityCompany', {
                                        initialValue: this.state.employer.City,
                                        rules: [{
                                            required: true, message: 'City',
                                        }],
                                    })(<Input disabled={this.state.inputControl} />)}
                                </FormItem>

                                <FormItem {...formItemLayout} label="State" >
                                    {getFieldDecorator('stateCompany', {
                                        initialValue: this.state.employer.State,
                                        rules: [
                                            { required: true, message: 'Please select your state!' },
                                        ],
                                    })(
                                        <Select
                                            disabled={this.state.inputControl}
                                            showSearch
                                            style={{ width: '40%' }}
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            {this.states}
                                        </Select >)}
                                </FormItem>

                                <FormItem {...midFormItemLayout} label="Zip Code">
                                    {getFieldDecorator('zipcodeCompany', {
                                        initialValue: this.state.employer.ZipCode,
                                        rules: [{ required: true, message: 'Please input your zip code!' },
                                        {
                                            validator: this.checkZipCode,
                                        }],
                                    })(
                                        <Input style={{ width: '100%' }} disabled={this.state.inputControl} />
                                    )}
                                </FormItem>
                                {/*------------------------------------------ EMPLOYER Contact ------------------------------------------*/}
                                <FormItem {...formItemLayout} label="Phone Number">
                                    {getFieldDecorator('phoneCompany', {
                                        initialValue: this.state.employer.PhoneNumber,
                                        rules: [{
                                            validator: this.checkZipPhone,
                                        }],
                                    })(
                                        <Input style={{ width: '100%' }} disabled={this.state.inputControl} />
                                    )}
                                </FormItem>
                                <FormItem {...formItemLayout} label="E-mail" >
                                    {getFieldDecorator('emailCompany', {
                                        initialValue: this.state.employer.Email,
                                        rules: [{
                                            type: this.state.emailValidatorEmployer, message: 'The input is not valid e-mail!'
                                        }, {
                                            validator: this.checkConfirm,
                                        }],
                                    })(
                                        <Input disabled={this.state.inputControl} onBlur={this.handleEmailValidationEmployer} />
                                    )}
                                </FormItem>
                               
                                {/*
                            <FormItem
                                {...formItemLayout}
                                label="Confirm Email"

                            >
                                {getFieldDecorator('emailConfirmCompany', {
                                    initialValue: this.state.employer.Email,
                                    rules: [{ required: this.props.form.getFieldValue('emailCompany') !== '', message: 'Please input your zip code!' },
                                    {
                                        validator: this.checkEmail,
                                    }],
                                })(
                                    <Input disabled={this.state.inputControl} onBlur={this.handleConfirmBlur} />
                                    )}
                            </FormItem>
                            */}
                                <Row>
                                    <Col span={24}>
                                        <button className="btn btn-default" onClick={() => this.handleCancel()}>Clear</button>
                                        <button style={{ marginLeft: 8 }} type="submit" className="btn btn-default" onClick={() => this.handleSubmit()}>Insert/Update</button>
                                        <button style={{ marginLeft: 8, display: this.state.employer.Id == -1 ? 'none' : 'inline' }}
                                            type="button" className='btn btn-danger' onClick={() => this.handleDelete()}>Delete</button>
                                    </Col>
                                </Row>

                            </Form>
                        </div>
                    </Spin>
                    : <Redirect to="/login" replace />
                }
            </div>
        );
    }

    handleSelectChangeSystem = (value) => {
        this.resetForm()
        this.setState({ filterSystem: value, initialModal:false });
        this.employerDropdown();
    }

    handleCancel = () => {

        this.setState({
            employer: {
                Id: -1, CompanyName: '', Address: '', State: '',
                City: '', ZipCode: '', PhoneNumber: '', Email: ''
            }
        });
        this.props.form.resetFields();

    }
    employerDropdown = () => {
        this.employerDisplayList = [];
        $.ajax({
            type: 'POST',
            url: `${config.serverUrl}/api/registration/getallemployer`,
        })
            .done((data) => {
                for (let i = 0; i < data.length; i++) {
                    if(data[i].System == this.state.filterSystem || this.state.filterSystem == "All"){
                        var optDis = data[i].CompanyName + ", " + data[i].City + " (" + data[i].State + ")";
                        this.employerDisplayList.push(
                            <Option key={data[i].Id}>{optDis}</Option>
                        );
                    }
                    
                }

                this.employerDisplayList.push(
                    <Option key="Other">Other</Option>
                );

                this.setState({
                    employerList: data
                });


            })
            .fail((jqXhr) => {
                console.log('failed to get employer');
            });

    }

    componentDidMount() {
        LoginForm.ValidateServerToken(() => { this.setState({ login: false }) });
        this.employerDropdown();

    }
}

const WrappedAddClassesForm = Form.create()(AddEmployerForm);

export default WrappedAddClassesForm;



// WEBPACK FOOTER //
// ./src/Admin/AddEmployerForm.js